import { Input } from "@comps/ui/input";
import { Notification } from "@comps/ui/notification";
import { Popover, PopoverContent, PopoverTrigger } from "@comps/ui/popover";
import { TW_ObjectModelViewHeaderButton, TW_ObjectModelViewHeaderIcon, TW_ObjectModelViewHeaderSearchClearIcon, TW_ObjectModelViewHeaderSearchCompactContainer, TW_ObjectModelViewHeaderSearchContainer, TW_ObjectModelViewHeaderSearchIcon, TW_ObjectModelViewHeaderSearchInput, TW_ObjectModelViewHeaderSearchPopoverContainer } from "@utils/twClasses";
import { Search, X } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataStore } from "src/store";

interface SearchInputProps {
  value: string;
  onChange: (text: string) => void;
}

function SearchInput({ value, onChange }: SearchInputProps) {
  const { t } = useTranslation();
  const edit = useDataStore(state => state.edit);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleFocus = () => {
    edit(null);
  };

  const handleClear = () => {
    onChange("");
  };

  return (
    <>
      {/* Below lg: only the search icon, the input lives in a popover */}
      <div className={TW_ObjectModelViewHeaderSearchCompactContainer}>
        <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
          <PopoverTrigger className={TW_ObjectModelViewHeaderButton}>
            <div className="flex flex-row justify-start items-center relative">
              <Search className={TW_ObjectModelViewHeaderIcon} />
              {value && <Notification number={null} />}
            </div>
          </PopoverTrigger>
          <PopoverContent className="w-max p-2">
            <div className={TW_ObjectModelViewHeaderSearchPopoverContainer}>
              <Search className={TW_ObjectModelViewHeaderSearchIcon} />
              <Input
                type="text"
                autoFocus
                placeholder={t("data.search.placeholder")}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onFocus={handleFocus}
                className={TW_ObjectModelViewHeaderSearchInput + (value ? " pr-8" : "")}
              />
              {value && (
                <X
                  className={TW_ObjectModelViewHeaderSearchClearIcon}
                  onClick={handleClear}
                />
              )}
            </div>
          </PopoverContent>
        </Popover>
      </div>
      {/* lg and up: inline search input */}
      <div className={TW_ObjectModelViewHeaderSearchContainer}>
        <Search className={TW_ObjectModelViewHeaderSearchIcon} />
        <Input
          type="text"
          placeholder={t("data.search.placeholder")}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={handleFocus}
          className={TW_ObjectModelViewHeaderSearchInput + (value ? " pr-8" : "")}
        />
        {value && (
          <X
            className={TW_ObjectModelViewHeaderSearchClearIcon}
            onClick={handleClear}
          />
        )}
      </div>
    </>
  );
}

export default SearchInput;
